module.exports = __webpack_public_path__ + "img/40_38_031_430.3ba3daab.jpg";